import React from 'react'
import axios from 'axios'
import InputMask from 'react-input-mask'

import Cidades from '../Cidades/Cidades.js'

import Cabecalho from '../Cabecalho/Cabecalho'
import Obs from '../Form/Obs'
import Button from '../Form/Button'

export default class NovoPaf extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                cpfCnpj: '', numero: '', estado: localStorage.estado, data: '', estabelecimento: '', fantasia: '', registro: '',
                endereco: '', municipio: '',
                uf: '', cep: '', telefone: '', fechadoObs: '', situacao: '', prazo: '', tipoEstabelecimento: '',
                nome: localStorage.nome, matricula: localStorage.matricula
            },
            municipios: [], buttonStatus: false
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/paf/getCpf/${id}`
        axios(url)
            .then(resp => {
                const ficha = { ...this.state.ficha }
                ficha.cpfCnpj = resp.data.cpfCnpj
                this.setState({ ficha })
                this.setState({ loaded: true })
            })
            .catch(error => {
                alert(error)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
        let cidades = Cidades[event.target.value]
        if (event.target.name == 'uf') {
            let uf = event.target.value
            const url = `ht://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
            axios.get(url, ficha)
                .then(resp => {
                    this.setState({ municipios: resp.data })
                })
                .catch(error => {
                    this.setState({ municipios: cidades })
                })
        }
    }

    save(e) {
        e.preventDefault()
        this.setState({ buttonStatus: true })
        const url = `/api/paf/novoPaf/${this.props.match.params.id}`
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert('PAF criado com sucesso!')
                window.location = `/documentosEstabelecimento/${this.props.match.params.id}`
            })
            .catch(error => {
                alert(error.response.data)
                this.setState({ buttonStatus: false })
            })
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Cabecalho />
                    <div className="form-group row mt-3 text-left">
                        <label className="col-3 col-md-2">CPF/CNPJ:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                value={this.state.ficha.cpfCnpj} />
                        </div>
                        <div className="col-12"></div>
                        <label className="col-3 col-md-2">Número:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                name="numero" onChange={e => this.updateField(e)} />
                        </div>
                        <div className="col-12"></div>
                        <label className="col-3 col-md-2">Data:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="date" className="form-control"
                                name="data" onChange={e => this.updateField(e)} />
                        </div>
                    </div>
                    <div className="mt-5 font-weight-bold text-left">
                        1 - DADOS DO ESTABELECIMENTO:
                    </div>
                    <div className="form-group row mt-3 text-left">
                        <label className="col-4 col-md-2">Estabelecimento:</label>
                        <div className="col-8 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                name="estabelecimento" onChange={e => this.updateField(e)} />
                        </div>
                        <label className="col-3 col-md-2">Nome Fantasia:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                name="fantasia" onChange={e => this.updateField(e)} />
                        </div>
                        <label className="col-3 col-md-2">Registro:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                name="registro" onChange={e => this.updateField(e)} />
                        </div>
                        <div className="col-12 col-md-6"></div>
                        <label className="col-3 col-md-2">Endereço:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                name="endereco" onChange={e => this.updateField(e)} />
                        </div>
                        <label className="col-3 col-md-2">UF:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <select className="custom-select"
                                name="uf" onChange={e => this.updateField(e)} >
                                <option value=""></option>
                                <option value="AL">Alagoas</option>
                                <option value="PB">Paraíba</option>
                                <option value="PE">Pernambuco</option>
                                <option value="RN">Rio Grande do Norte</option>
                            </select>
                        </div>
                        <label className="col-3 col-md-2">Município:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <select className="custom-select"
                                name="municipio" onChange={e => this.updateField(e)} >
                                <option value=""></option>
                                {this.renderMunicipios()}
                            </select>
                        </div>
                        <label className="col-3 col-md-1">CEP:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <InputMask type="text" className="form-control"
                                mask="99999-999"
                                name="cep" onChange={e => this.updateField(e)} />
                        </div>
                        <label className="col-3 col-md-2">Telefone:</label>
                        <div className="col-9 col-md-3 mb-3">
                            <InputMask type="text" className="form-control"
                                mask="(99)99999-9999"
                                name="telefone" onChange={e => this.updateField(e)} />
                        </div>
                        <label className="col-4 col-md-2">Situação:</label>
                        <div className="col-8 col-md-4 mb-3">
                            <select className="custom-select"
                                name="situacao" onChange={e => this.updateField(e)} >
                                <option value=""></option>
                                <option value="Revisita">Revisita</option>
                                <option value="Arquivo">Arquivo</option>
                                <option value="Aguardando prazo">Aguardando prazo</option>
                                <option value="Processo Ético">Processo Ético</option>
                                <option value="Coordenação">Coordenação</option>
                                <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                                <option value="Presidência">Presidência</option>
                                <option value="Novo">Novo</option>
                            </select>
                        </div>
                        {this.renderPrazo()}
                        <label className="col-4 col-md-2">Tipo:</label>
                        <div className="col-8 col-md-4 mb-3">
                            <select className="custom-select"
                                name="tipoEstabelecimento" onChange={e => this.updateField(e)} >
                                <option value=""></option>
                                <option value="Consultorio">Consultório</option>
                                <option value="Caps">Caps</option>
                                <option value="Clínica">Clínica</option>
                                <option value="Nasf">Nasf</option>
                                <option value="CER">CER</option>
                                <option value="Ilpis">Ilpis</option>
                                <option value="Hospital">Hospital</option>
                                <option value="Outros">Outros</option>
                            </select>
                        </div>
                        <label className="col-4 col-md-2">Classe do Estabelecimento:</label>
                        <div className="col-8 col-md-4 mb-3">
                            <select className="custom-select"
                                name="classeEstabelecimento" onChange={e => this.updateField(e)} >
                                <option value=""></option>
                                <option value="Físico">Físico</option>
                                <option value="Virtual">Virtual</option>
                            </select>
                        </div>
                    </div>
                    <Obs nome="fechadoObs" value={this.state.ficha}
                        onChange={e => this.updateField(e)} />
                    <button className='btn btn-success'
                        onClick={e => this.save(e)} disabled={this.state.buttonStatus}>Enviar</button>
                    {/* <Button onClick={e => this.save(e)} /> */}
                </div>
            </React.Fragment>
        )
    }

    renderPrazo() {
        if (this.state.ficha.situacao == "Aguardando prazo") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Prazo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="date" className="form-control"
                            name="prazo" onChange={e => this.updateField(e)} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderMunicipios() {
        let select = []
        this.state.municipios.map(municipio => {
            select.push(<option value={municipio.nome}>{municipio.nome}</option>)
        })
        return select
    }
}